import { IconButton, Tooltip } from '@material-ui/core';
import { SvgIconProps } from '@material-ui/core/SvgIcon';

export interface ActionButtonProps {
  url?: string;
  tooltip: string;
  icon: React.ComponentType<SvgIconProps>;
  ariaLabel: string;
  onClick?: () => void;
  condition?: boolean;
}

export const ActionButton: React.FC<ActionButtonProps> = ({
  url,
  tooltip,
  icon: Icon,
  ariaLabel,
  onClick,
  condition = true,
}) => {
  if (!condition || (!url && !onClick)) {
    return null;
  }

  if (url && !onClick) {
    return (
      <Tooltip title={tooltip}>
        <IconButton
          aria-label={ariaLabel}
          component="a"
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          size="small"
        >
          <Icon />
        </IconButton>
      </Tooltip>
    );
  }

  return (
    <Tooltip title={tooltip}>
      <IconButton aria-label={ariaLabel} onClick={onClick} size="small">
        <Icon />
      </IconButton>
    </Tooltip>
  );
};
